<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	      <el-form-item style="width:12%">
	          <el-date-picker v-model="query.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	      </el-form-item>
	      <el-form-item style="width:12%">
	          <el-date-picker v-model="query.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	      </el-form-item>
          <el-form-item style="width:13%">
          	  <el-select v-model="query.seller" clearable filterable placeholder="请选采购人" style="width:100%" @change="isselect=true">
				  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
			  </el-select>
		  </el-form-item>
		  <el-form-item style="width:13%">
              <el-select v-model="query.supplier" clearable filterable placeholder="请选供应商" style="width:100%" @change="isselect=true">
				  <el-option v-for="(item,index) in supplierlists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
			  </el-select>
          </el-form-item>
	      <el-form-item>
	          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	      </el-form-item>
	      <!--
	      <el-form-item>
	          <template>
	          	  <div style="color:#ffd700;font-weight:bold">收款合计：￥{{allamount}}</div>
	          </template>
	      </el-form-item>
	      -->
	  </el-form>
	  
	  <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listLoading">
	      	  <el-table-column prop="name" label="供应商名称"></el-table-column>
	      	  <el-table-column prop="amount" label="金额" width="200"></el-table-column>
	      </el-table>
	      <div class="block">
	      <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	      <!--分页end-->
	      </div>
      </div>
	  
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Stat/index",
      query: {
      	  act:'getpayhistory',
      	  token:this.$cookies.get('token'),
      	  start:'',
      	  end:'',
      	  supplier:'',
      	  seller:'',
      	  p:1,
      	  rollpage:10,
      },
      isselect:false,
      typelists:[{id:1,name:'按客户统计'},{id:2,name:'按销售员统计'}],
      sellerLists:[],
      listLoading:false,
      total_rows:0,
      allamount:0.00,
      supplierlists:[],
      
    }
  },
  mounted(){
    this.getactionauth();
    this.getList();
    this.getSeller();
    this.getSupplier();
  },
  
  methods:{
  
    /** 获取操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取供应商信息 **/
    getSupplier() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplylists',token:this.$cookies.get('token'),p:1,rollpage:10}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);
            }else{
				this.supplierlists=JSON.parse(Base64.decode(res.data.Data));			
            }
        }).catch((res) => {
            
        });
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                     
	        }
        }).catch((res) => {
            
        });
    },
    
    /** 获取入库信息列表 **/
    getList(){
    	if(this.isselect==true) {
    		this.query.p=1;
    		this.query.rollpage=10;
    	}
    
        this.listLoading=true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);	            
	            this.listLoading=false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.lists=result;
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading=false;
	            if(this.isselect==true) this.isselect=false;
	        }
        }).catch((res) => {
			this.listLoading=false;
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Paystat.vue